import { c as _c } from "react/compiler-runtime";
import { ArrowLeftIcon } from "@navikt/aksel-icons";
import { Button, HStack, VStack } from "@navikt/ds-react";
import NextLink from "next/link";
import { useParams } from "next/navigation";
import { knappKlikket } from "@/common/analytics/events-and-properties/knappKlikket-properties";
import { getAGOversiktHref } from "@/common/route-hrefs";
import { TrackedButton } from "@/ui/TrackedButton";
interface Props {
  isPendingFerdigstill: boolean;
  onGoBackClick: () => void;
  onFerdigstillPlanClick: () => void;
}
export default function OppsummeringButtons(t0) {
  const $ = _c(18);
  const {
    isPendingFerdigstill,
    onGoBackClick,
    onFerdigstillPlanClick
  } = t0;
  const {
    narmesteLederId
  } = useParams();
  let t1;
  if ($[0] !== narmesteLederId) {
    t1 = getAGOversiktHref(narmesteLederId);
    $[0] = narmesteLederId;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const oversiktHref = t1;
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <ArrowLeftIcon aria-hidden={true} />;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== isPendingFerdigstill || $[4] !== onGoBackClick) {
    t3 = <TrackedButton variant="secondary" iconPosition="left" icon={t2} onClick={onGoBackClick} disabled={isPendingFerdigstill} tracking={knappKlikket.nyPlanSide.oppsummeringSteg.gaTilbake}>Gå tilbake</TrackedButton>;
    $[3] = isPendingFerdigstill;
    $[4] = onGoBackClick;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== isPendingFerdigstill || $[7] !== onFerdigstillPlanClick) {
    t4 = <Button variant="primary" onClick={onFerdigstillPlanClick} loading={isPendingFerdigstill}>Ferdigstill og del med den ansatte</Button>;
    $[6] = isPendingFerdigstill;
    $[7] = onFerdigstillPlanClick;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  let t5;
  if ($[9] !== t3 || $[10] !== t4) {
    t5 = <HStack gap="space-32">{t3}{t4}</HStack>;
    $[9] = t3;
    $[10] = t4;
    $[11] = t5;
  } else {
    t5 = $[11];
  }
  let t6;
  if ($[12] !== isPendingFerdigstill || $[13] !== oversiktHref) {
    t6 = isPendingFerdigstill ? <Button variant="tertiary" disabled={true}>Avslutt og fortsett senere</Button> : <TrackedButton variant="tertiary" as={NextLink} href={oversiktHref} tracking={knappKlikket.nyPlanSide.oppsummeringSteg.avsluttOgFortsettSenere}>Avslutt og fortsett senere</TrackedButton>;
    $[12] = isPendingFerdigstill;
    $[13] = oversiktHref;
    $[14] = t6;
  } else {
    t6 = $[14];
  }
  let t7;
  if ($[15] !== t5 || $[16] !== t6) {
    t7 = <VStack gap="space-32" align="start">{t5}{t6}</VStack>;
    $[15] = t5;
    $[16] = t6;
    $[17] = t7;
  } else {
    t7 = $[17];
  }
  return t7;
}